import { diffCalendarMonth, diffCalendarYear } from "./diff-calendar-unit";
import { isValidDate } from '../create/create-ts-date';
function diffPreciseByUnits(unitsInMs) {
    return (function (d1, d2) {
        if (!isValidDate(d1) || !isValidDate(d2))
            return null;
        return (d1.getTime() - d2.getTime()) / unitsInMs;
    });
}
export var diffPreciseSeconds = diffPreciseByUnits(1000 /* Seconds */);
export var diffPreciseMinutes = diffPreciseByUnits(60000 /* Minutes */);
export var diffPreciseHours = diffPreciseByUnits(3600000 /* Hours */);
export var diffPreciseDate = diffPreciseByUnits(86400000 /* Date */);
export var diffPreciseMonth = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var startOfMonth1 = +new Date(d1.getFullYear(), d1.getMonth());
    var startOfNextMonth1 = +new Date(d1.getFullYear(), d1.getMonth() + 1);
    var startOfMonth2 = +new Date(d2.getFullYear(), d2.getMonth());
    var startOfNextMonth2 = +new Date(d2.getFullYear(), d2.getMonth() + 1);
    var m1 = startOfNextMonth1 - startOfMonth1;
    var m2 = startOfNextMonth2 - startOfMonth2;
    var t1 = d1.getTime() - startOfMonth1;
    var t2 = d2.getTime() - startOfMonth2;
    /**
     * that formula was made to avoid "1 - 0.9" calculations
     * do same thing as
     * diffCalendarMonth(d1, d2) + t1 / m1 - t2 / m2
     */
    return (diffCalendarMonth(d1, d2) * m1 * m2 + t1 * m2 - t2 * m1) / (m1 * m2);
};
export var diffPreciseYear = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var startOfYear1 = +new Date(d1.getFullYear(), 0);
    var startOfNextYear1 = +new Date(d1.getFullYear() + 1, 0);
    var startOfYear2 = +new Date(d2.getFullYear(), 0);
    var startOfNextYear2 = +new Date(d2.getFullYear() + 1, 0);
    var y1 = startOfNextYear1 - startOfYear1;
    var y2 = startOfNextYear2 - startOfYear2;
    var t1 = d1.getTime() - startOfYear1;
    var t2 = d2.getTime() - startOfYear2;
    return (diffCalendarYear(d1, d2) * y1 * y2 + t1 * y2 - t2 * y1) / (y1 * y2);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/diff/diff-precise-unit.js
// module id = null
// module chunks = 